<template>
  <my-view :GetAddrList="GetAddrList" :AddAddress="AddAddress" :UpdateAddress="UpdateAddress" :DelAddress="DelAddress" :SetDefaultAddress="SetDefaultAddress" :GetProList="GetProList" :GetDisList="GetDisList" :GetTownList="GetTownList"></my-view>
</template>

<script>
import {
  GetAddrList,
  AddAddress,
  UpdateAddress,
  DelAddress,
  SetDefaultAddress,
} from "@/pages/page1/api/modules/user";
import {
  GetProList,
  GetDisList,
  GetTownList,
} from "@/pages/page1/api/modules/common";

import MyView from "@/pages/publicView/personalCenter/shipAddress_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      GetAddrList,
      AddAddress,
      UpdateAddress,
      DelAddress,
      SetDefaultAddress,
      GetProList,
      GetDisList,
      GetTownList,
    };
  },
};
</script>